import { Link } from "@inertiajs/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import ContentLayout from "../shared/ContentLayout";
import PageHeader from "../shared/PageHeader";
import ReferenceCard from "../Home/sections/FeaturedContent/strategies/ReferenceCard";

interface Reference {
  id: number;
  title: string;
  path: string;
  image_url: string | null;
  text_preview: string | null;
}

interface Section {
  id: number;
  title: string;
  description: string | null;
}

interface SectionInfo {
  id: number;
  title: string;
}

export default function ReferencesSectionShow({
  section,
  references,
  nextSection,
  previousSection,
}: {
  section: Section;
  references: Reference[];
  nextSection: SectionInfo | null;
  previousSection: SectionInfo | null;
}) {
  const renderBreadcrumbs = () => (
    <div className="flex justify-between items-center">
      <div className="breadcrumbs text-sm">
        <ul>
          <li>
            <Link href="/" className="link link-primary">
              Home
            </Link>
          </li>
          <li>
            <Link href="/references" className="link link-primary">
              References
            </Link>
          </li>
          <li>
            <span>{section.title}</span>
          </li>
        </ul>
      </div>

      <div className="flex gap-2">
        {previousSection && (
          <Link
            href={`/references/${previousSection.id}`}
            className="btn btn-outline btn-primary btn-xs"
            title={previousSection.title}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </Link>
        )}
        {nextSection && (
          <Link
            href={`/references/${nextSection.id}`}
            className="btn btn-outline btn-primary btn-xs"
            title={nextSection.title}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </Link>
        )}
      </div>
    </div>
  );

  const renderFooterNavigation = () => (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <div>
        {previousSection && (
          <Link
            href={`/references/${previousSection.id}`}
            className="btn btn-sm btn-outline btn-primary w-full justify-start"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
            <span className="truncate">{previousSection.title}</span>
          </Link>
        )}
      </div>

      <div className="flex items-center justify-center">
        <Link href="/references" className="btn btn-primary btn-sm">
          All References
        </Link>
      </div>

      <div>
        {nextSection && (
          <Link
            href={`/references/${nextSection.id}`}
            className="btn btn-sm btn-outline btn-primary w-full justify-end"
          >
            <span className="truncate">{nextSection.title}</span>
            <FontAwesomeIcon icon={faChevronRight} />
          </Link>
        )}
      </div>
    </div>
  );

  return (
    <ContentLayout
      breadcrumbs={renderBreadcrumbs()}
      footerNavigation={renderFooterNavigation()}
    >
      <div className="p-3 sm:p-4 max-w-4xl">
        <PageHeader title={section.title} description={section.description || undefined} />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {references.map((reference) => (
            <ReferenceCard item={reference} sectionId={section.id} />
          ))}
        </div>
      </div>
    </ContentLayout>
  );
}
